import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Fade from "@mui/material/Fade";
import { Box, Typography, styled } from "@mui/material";
import Button from "../../components/Button";
import { getSx } from "../../components/Modal/style";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Fade ref={ref} {...props} />;
});

const CustomDialog = styled(Dialog)(() => ({
    "& .MuiDialog-paper": {
        width: "400px",
        padding: "30px",
        borderRadius: "20px",
    },
    "& .MuiPaper-root": { maxWidth: "400px" },
    "& .MuiDialogActions-root": {},
}));

export default function ConfirmDelete({ open, setOpen, confirmDelete }) {
    const classes = getSx(true);

    const confirmHandler = () => {
        setOpen(false)
        confirmDelete()
    }

    const closeModalHandler = () => setOpen(false)

    return (
        <CustomDialog
            open={open}
            keepMounted
            onClose={() => setOpen(false)}
            TransitionComponent={Transition}
            sx={{ "& .MuiPaper-root": { maxWidth: "400px" } }}
        >
            <DialogContent sx={{ padding: "8px 20px" }}>
                <Box sx={{ ...classes.subTitleContainer, gap: "1rem" }}>
                    <Box>
                        <Typography
                            sx={{
                                fontSize: "20px",
                                minWidth: "300px",
                                maxWidth: "400px",
                                textAlign: "center",
                                marginBottom: "10px"
                            }}
                        >
                            Are you sure you want to delete?
                        </Typography>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions
                disableSpacing={false}
                sx={{ ...classes.buttonWrapper, justifyContent: "center" }}
            >
                <Button
                    style={{ ...classes.button, width: "100px", borderRadius: "12px" }}
                    label="Delete"
                    onClick={confirmHandler}
                />
                <Button
                    style={{ ...classes.button, width: "100px", borderRadius: "12px" }}
                    label="Cancel"
                    onClick={closeModalHandler}
                />
            </DialogActions>

        </CustomDialog >
    );
}
